import AuthContainer from 'components/AuthContainer/AuthContainer.tsx'
import { Heading } from '@boltenergy-be/design-system'

const ErrorElement = () => (
  <AuthContainer>
    <Heading as="h2" variant="h3" serif>
      Something went wrong while fetching your route.
    </Heading>
    <p>Please contact support if this issue persists.</p>
  </AuthContainer>
)

export default ErrorElement
